// extracted by mini-css-extract-plugin
module.exports = {"caseInDevelop":"styles-module--case-in-develop--2vQ05","caseInDevelop__content":"styles-module--case-in-develop__content--1KNj9"};